<template>
  <NuxtLayout
    name="generic"
    header="none"
    footer="lp"
  >
    <main v-if="data">
      <EnterpriseHero
        v-if="data.abmHero"
        :abm-hero="data.abmHero"
      />

      <AnchorMenuSections
        v-if="data.content"
        v-bind="data.content"
        :class="{
          'px-0 text-www-color-neutral-medium-dark': true,
        }"
      />

      <CTABanner
        v-if="ctaData"
        :data="ctaData"
      />
    </main>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { QueryEnterpriseResult } from '~/sanity/types';
import { queryEnterprise } from '~/queries/pages/PageEnterprise.query';
import { useRefsStore } from '~/composables/refsStore';
import EnterpriseHero from '~/components/Organisms/EnterpriseHero/EnterpriseHero.vue';
import AnchorMenuSections from '~/components/Atmos/AnchorMenuSections/AnchorMenuSections.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';

const { getResolvedCTABanner } = useRefsStore();

const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQueryNonNull<QueryEnterpriseResult>(queryEnterprise, {
  currentPathname,
});

const ctaData = await getResolvedCTABanner(data.value?.CTABanner?.reference?._ref);

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  title: data.value?.htmlTitle || data.value?.abmHero.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
});
</script>
